var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"background pa-4 mb-4",staticStyle:{"border":"1px solid currentColor !important"},attrs:{"flat":""}},[_c('div',{staticClass:"text-subtitle-1 font-weight-medium"},[_vm._v(" Permissions ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }